const s = {
  name: "Sound",
  dimensions: { width: 40, height: 28 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 28.3" style="enable-background:new 0 0 40 28.3;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M32.7,1.4C36,4.7,38,9.2,38,14.1c0,5-2,9.5-5.3,12.7l1.4,1.4c3.6-3.6,5.9-8.6,5.9-14.1
			C40,8.6,37.8,3.6,34.1,0L32.7,1.4z"/>
		<path class="st0" d="M26,13.8c-0.1-1.5-0.7-2.9-1.7-3.9l-1.4,1.4C23.6,12,24,13,24,14.1c0,1.1-0.4,2.1-1.2,2.8l1.4,1.4
			c0.1-0.1,0.3-0.3,0.4-0.4c0.8-1,1.4-2.4,1.4-3.8l0,0C26,14,26,13.9,26,13.8z"/>
		<path class="st0" d="M18,1.5v25.4L5.7,20.1H0v-12h5.7L18,1.5z M2,18.1h3v-8H2V18.1z M7,9.7v8.8l9,4.9V4.8L7,9.7z"/>
		<path class="st0" d="M27.8,6.4c2,2,3.2,4.7,3.2,7.8s-1.2,5.8-3.2,7.8l1.4,1.4c2.4-2.4,3.8-5.6,3.8-9.2s-1.5-6.8-3.8-9.2L27.8,6.4z
			"/>
	</g>
</g>
</svg>
  `
};
export {
  s as Sound
};
